import { motion } from 'framer-motion';
import styled from 'styled-components';

type ActionToastWrapperProps = {
    $wide?: boolean;
};

export const ActionToastWrapper = styled(motion.div)<ActionToastWrapperProps>`
    overflow: hidden;
    position: absolute;
    bottom: 0;
    left: 50%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 60px;

    transition: width 0.2s ease-in-out;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        justify-content: space-between;
        bottom: 20px;
        padding: 0 10px 0 20px;

        width: ${({ $wide }) => ($wide ? '350px' : '280px')};

        background: ${({ theme }) => theme.colors.purple};
        box-shadow: 0 4px 30px ${({ theme }) => theme.shades.black['30']};
        border-radius: 100px;
    }
`;
